import { Kb3dModel } from '../decorators/kb3d-decorator';
import { IVertexGroup } from '../kb3d-models';
import { Token } from '../token';
import { Feature, eMeshChangeTypes } from './feature';

@Kb3dModel({
    token: Token.ChamferFeature,
})
export class ChamferFeature extends Feature {
    // NOTE:
    // - Keep this minimal: only level + face selection groups (UI-managed).
    // - We mirror DeleteFacesFeature's dependency declarations to keep behavior conservative.
    //   You can broaden _affects later (e.g., include VertexPositions/VertexNormals) when
    //   the geometry processor is ready to output those changes.

    static _dependsOn = new Set([
        eMeshChangeTypes.VertexIndices,
        eMeshChangeTypes.VertexPositions,
    ]);

    static _affects = new Set([
        eMeshChangeTypes.VertexIndices,
        eMeshChangeTypes.Submeshes,
        eMeshChangeTypes.VertexPositions,
        eMeshChangeTypes.VertexNormals,
        eMeshChangeTypes.VertexUvs,
    ]);

    static _affectedBy = new Set([
        eMeshChangeTypes.VertexIndices,
        eMeshChangeTypes.VertexPositions,
        eMeshChangeTypes.Submeshes,
    ]);

    // Controls the size of the chamfer inner face.
    // 0 = smallest possible inner face, 1 = inner face matches original, greater than 1 = grows beyond the original face.
    chamferSize: number = 0.5;

    // Offset of the inner face along the face normal.
    // Positive values protrude outward, negative values recess inward. Accepts any magnitude.
    chamferProtusion: number = 0.25;

    // Face selection groups (UI will populate these via the face selection gizmo)
    vertexGroups: Array<Required<IVertexGroup>> = [];
}